export const NAME = "AUTH";
